var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96816 8.26286L11.8531 11.1478C12.049 11.3412 12.049 11.6596 11.8531 11.8531C11.6571 12.049 11.3412 12.049 11.1453 11.8531L8.26041 8.97061C7.38857 9.68571 6.27429 10.1143 5.05714 10.1143C2.26286 10.1143 0 7.84898 0 5.05714C0 2.26531 2.26286 0 5.05714 0C7.84898 0 10.1143 2.26531 10.1143 5.05714C10.1143 6.27429 9.68327 7.39102 8.96816 8.26286ZM1.00408 5.05714C1.00408 7.29061 2.82122 9.10776 5.05714 9.10776C7.29061 9.10776 9.1102 7.29061 9.1102 5.05714C9.1102 2.82367 7.29061 1.00408 5.05714 1.00408C2.82122 1.00408 1.00408 2.82367 1.00408 5.05714Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconSmall);
export default __webpack_public_path__ + "static/media/search_icon_small.f8cadfc92690a24952fb48c0dd1b6237.svg";
export { ForwardRef as ReactComponent };